import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../Confg/firebaseConfig';

/**
 * Estado de BLOQUEIO da loja operada, ao vivo.
 *
 * É um listener próprio (1 documento) em vez de reaproveitar o merchantData do
 * UserContext por um motivo: aquele é lido UMA vez e guardado em sessionStorage. Um
 * bloqueio feito pelo suporte às 14h só chegaria ao lojista no próximo F5 — e o
 * ponto do bloqueio é justamente valer na hora, com a loja aberta na tela.
 *
 * Lê `selectedStoreUid` para o MODO ADMIN ver a mesma tela que o lojista vê.
 *
 * @returns {{ carregando: boolean, bloqueada: boolean, motivo: string|null, desde: Date|null }}
 */
export default function useStoreBlock(uidLogado) {
  const [estado, setEstado] = useState({ carregando: true, bloqueada: false, motivo: null, desde: null });

  useEffect(() => {
    let lojaId = null;
    try { lojaId = localStorage.getItem('selectedStoreUid'); } catch { /* modo privado */ }
    lojaId = lojaId || uidLogado;
    if (!lojaId) {
      setEstado({ carregando: false, bloqueada: false, motivo: null, desde: null });
      return undefined;
    }

    const unsub = onSnapshot(
      doc(db, 'merchants', lojaId),
      (snap) => {
        const d = snap.exists() ? snap.data() : {};
        const raw = d.blockedAt;
        const desde = raw?.toDate ? raw.toDate() : (raw ? new Date(raw) : null);
        setEstado({
          carregando: false,
          bloqueada: d.blocked === true,
          motivo: d.blockedReason || null,
          desde: desde && !isNaN(desde.getTime()) ? desde : null,
        });
      },
      // Regra negando leitura não pode DERRUBAR a loja: na dúvida, não bloqueia.
      () => setEstado({ carregando: false, bloqueada: false, motivo: null, desde: null })
    );
    return () => unsub();
  }, [uidLogado]);

  return estado;
}
